import { render, staticRenderFns } from "./MerchantReportSettingsModal.vue?vue&type=template&id=6af1d9c2&scoped=true"
import script from "./MerchantReportSettingsModal.vue?vue&type=script&lang=js"
export * from "./MerchantReportSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./MerchantReportSettingsModal.vue?vue&type=style&index=0&id=6af1d9c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af1d9c2",
  null
  
)

export default component.exports